module.exports = __webpack_public_path__ + "img/bull_main.95ad4354.gif";